<template>
    <div>
      <div 
        @click="launchFile()">
        <slot name="activator"></slot>
      </div>
  
      <input 
        type="file"
        accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        ref="file"
        :name="filename"
        v-on:change="changeFile($event.target.files)"
        style="display:none">
  
      <v-dialog 
        v-model="dialog"
        width="500">
        <v-card
          class="pa-0 ma-0"
          flat>
          <v-card
            color="red accent-2">
            <v-list-item>
              <v-list-item-avatar 
                color="red accent-2" 
                size="30">
                <v-icon color="white" large>mdi-alert</v-icon>
              </v-list-item-avatar>
  
              <v-list-item-content>
                <v-card-text 
                  class="caption white--text pa-0">
                  {{ message.error }}
                </v-card-text>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
    export default {
      name: 'upload-document',
      data: () => ({
        dialog: false,
        filename: 'file',
        message: {
          success: '',
          error: ''
        },
        process: {
          form: false
        }
      }),
      methods: {
        launchFile () {
          this.$refs.file.click()
        },
        changeFile (file) {
          let document = file[0]
          if (file.length > 0) {
            if (document.type != 'application/vnd.ms-excel' && document.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
              this.dialog = true
              this.message.error = 'Silahkan pilih dokumen dengan format .xls / .xlsx'
            } else if (document.size > 10485760) {
              this.dialog = true
              this.message.error = 'Maksimal dokumen 10MB'
            } else {
              // console.log(document)
              this.$emit('input', {
                  filename: document.name,
                  // filepath: document.file_path,
                  fileuri: document,
                  filesize: document.size,
                  filemime: document.type,
                  process : this.process.form
                })
              // let formData = new FormData()
              //     formData.append('api-key', 'd3f8bfb9d73c9ced96c369186ea2743e')
              //     formData.append('client-key', 'apikdce584a2be25dd8ae3cc403c3532')
              //     formData.append('files[]', document)
              //     formData.append('user_id', this.$store.state.user.id)
  
              // this.process.form = true
  
              // this.$emit('input', {
              //   process: this.process.form
              // })
  
              // fetch(`${process.env.VUE_APP_API_CDN}document`, {
              //   method: 'POST',
              //   body: formData
              // })
              // .then(res => res.json())
              // .then(response => {
              //   this.process.form = false
  
              //   this.$emit('input', {
              //     filename: response.data[0].data.file_name,
              //     // filepath: response.data[0].data.file_path,
              //     fileuri: response.data[0].data.file_url,
              //     filesize: document.size,
              //     filemime: document.type,
              //     process : this.process.form
              //   })
              // })
            }
          }
        }
      }
    }
  </script>